import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { deleteProduct } from 'utils/api';
import { toast } from 'react-toastify';
import SpinnerButton from 'components/SpinnerButton';

const DeleteProductModal = ({ isOpen, toggle, product, refreshList }) => {
    const [deleting, setDeleting] = useState(false);

    const onConfirm = async () => {
        try {
            setDeleting(true);
            await deleteProduct(product.id);
            await refreshList(true);
            toast.success('Product successfully deleted');
            toggle();
        } catch (err) {
            setDeleting(false);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            } else {
                toast.error('Unable to complete your request at this time');
            }
            console.log(err);
        }
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Delete Product</strong>
            </ModalHeader>
            <ModalBody>
                <div style={{ paddingRight: 25 }}>
                    Are you sure you want to delete {product.name}?
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{ color: 'white' }} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    minWidth="85px"
                    onClick={onConfirm}
                    title="Confirm"
                    submitting={deleting}
                />
            </ModalFooter>
        </Modal>
    );
};

export default DeleteProductModal;